import { NotificationModal } from '@components/ui';
import { ModalProps } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';

interface Props extends Omit<ModalProps, 'children'> {}

export function MaxEmployeesReachedModal({ ...props }: Props) {
  const { t } = useTranslation();
  return (
    <NotificationModal {...props}>
      <div className="flex flex-col gap-5 p-5 md:p-12">
        <div className="text-xl font-semibold">{t('dashboard.training.employee.table.maxreachedmodal.title')}</div>
        <p>
          <Trans t={t} i18nKey={'dashboard.training.employee.table.maxreachedmodal.body'}>
            Du hast die maximale Anzahl an Mitarbeitern erreicht. Bitte lösche einen vorhandenen Mitarbeiter oder
            upgrade deinen Plan, um weitere Mitarbeiter hinzuzufügen.
          </Trans>
        </p>
      </div>
    </NotificationModal>
  );
}
